import React from 'react';
import { Box, Typography, Button, Grid, Paper, Alert } from '@mui/material';

const OfficeList = ({ offices = [], onEdit, officeError }) => {
    return (
        <Box className="officeContainer" sx={{ mt: 2 }}>
            {officeError && <Alert severity="error" sx={{ mb: 2 }}>{officeError}</Alert>}

            {offices.map((office) => (
                <Paper key={office._id} sx={{ p: 2, mb: 2, border: '1px solid gray' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="subtitle2">Название:</Typography>
                            <Typography>{office.name}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={5}>
                            <Typography variant="subtitle2">Адрес:</Typography>
                            <Typography>{office.address}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => onEdit(office)}
                            >
                                Редактировать
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            ))}
        </Box>
    );
};

export default OfficeList;